import cx from 'classnames'
import FinalizedReportFooter from './FinalizedReportFooter'
import { EntityConfig } from './FinalizedReportPreviewEmbedded'
import DraftWatermark from './DraftWatermark'

const pageClasses = [
  'break-after-page',
  'min-h-[100vh]',
  'flex',
  'flex-col',
  'justify-between',
  'print:mt-0',
  'shadow-lg',
  'print:shadow-none',
  'bg-white',
  'page-padding',
  'mt-10',
  'relative'
]

const printClasses = ['print:mt-0', 'print:print-safe-padding']

export default function FinalizedReportPage({
  children,
  isPreview = false,
  pageNumber,
  totalPage,
  entityConfig,
  footNote,
  selectedPdfLanguage,
  showWatermark = false
}: {
  children: React.ReactNode
  isPreview?: boolean
  pageNumber: string
  totalPage: string
  entityConfig: EntityConfig
  footNote?: string | null
  selectedPdfLanguage?: string
  showWatermark?: boolean
}) {
  return (
    <div
      className={cx(pageClasses, printClasses, {
        'h-[1122px] w-[794px] mx-auto': isPreview
      })}
    >
      {showWatermark && <DraftWatermark />}

      <div className="flex-1">{children}</div>
      {footNote && <p className="text-xs text-text-secondary text-left px-2 mb-2">{footNote}</p>}
      <FinalizedReportFooter
        pageNumber={pageNumber}
        totalPage={totalPage}
        entityConfig={entityConfig}
        selectedPdfLanguage={selectedPdfLanguage}
      />
    </div>
  )
}
